import { useEffect } from 'react';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const EVizePage = () => {
  useEffect(() => {
    document.title = 'E-Vize Hizmetleri | İzmir Vize Danışmanlığı';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Online e-vize başvuruları. Dubai, Rusya, Vietnam, Küba ve daha fazla ülke için elektronik vize hizmetleri.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://public.readdy.ai/ai/img_res/25b39b2162d261bf2634a418ced9ea0c.jpg"
              alt="E-Vize"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-navy-900/95 via-navy-900/90 to-navy-900/95"></div>
          </div>
          
          <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="inline-block px-4 py-2 md:px-6 md:py-3 bg-cream-400 text-navy-900 text-xs font-semibold tracking-widest uppercase rounded-full mb-4 md:mb-6">
              Elektronik Vize
            </span>
            <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-cream-100 mb-4 md:mb-6">
              E-Vize Danışmanlığı
            </h1>
            <p className="text-cream-200 text-base md:text-xl lg:text-2xl leading-relaxed mb-6 md:mb-8">
              Online başvuru ile hızlı ve kolay elektronik vize hizmetleri
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-green-600 text-white rounded-full font-bold text-sm md:text-lg hover:bg-green-700 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl mr-2"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-cream-400 text-navy-900 rounded-full font-bold text-sm md:text-lg hover:bg-cream-300 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-xl md:text-2xl mr-2"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                E-Vize Nedir?
              </h2>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-6">
                E-Vize (Elektronik Vize), tamamen online olarak başvurulan ve elektronik ortamda onaylanan vize türüdür. Konsolosluk ziyareti gerektirmeden, internet üzerinden başvuru yapılır ve onaylanan vize e-posta yoluyla gönderilir. Seyahat öncesi bu belgeyi yazdırmanız yeterlidir.
              </p>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-8">
                E-Vize sistemi, vize süreçlerini hızlandırmak ve kolaylaştırmak amacıyla birçok ülke tarafından uygulanmaktadır. Geleneksel vize başvurularına göre çok daha hızlı sonuçlanır ve genellikle 24-72 saat içinde onaylanır. Ancak her ülkenin e-vize gereksinimleri ve prosedürleri farklılık gösterir.
              </p>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                E-Vize Avantajları
              </h2>
              <div className="grid md:grid-cols-3 gap-4 md:gap-6 mb-8">
                <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-cream-400 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-time-line text-2xl text-navy-900"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-cream-100 mb-2">Hızlı Süreç</h3>
                  <p className="text-cream-200 text-sm">24-72 saat içinde onay alabilirsiniz. Acil durumlar için ideal çözüm.</p>
                </div>
                <div className="bg-gradient-to-br from-cream-400 to-cream-300 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-computer-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Online Başvuru</h3>
                  <p className="text-navy-700 text-sm">Konsolosluk ziyareti gerekmez, her yerden başvuru yapabilirsiniz.</p>
                </div>
                <div className="bg-gradient-to-br from-cream-300 to-cream-200 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-file-text-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Basit Evrak</h3>
                  <p className="text-navy-700 text-sm">Minimum evrak gereksinimi, karmaşık belgeler gerekmez.</p>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                E-Vize Verilen Popüler Ülkeler
              </h2>
              
              <div className="space-y-6 mb-8">
                <div className="bg-cream-50 rounded-2xl p-6 border-2 border-cream-200">
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-navy-900 rounded-xl flex items-center justify-center flex-shrink-0">
                      <span className="text-3xl">🇦🇪</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Dubai (BAE) E-Vizesi</h3>
                      <p className="text-navy-600 text-sm mb-3">Birleşik Arap Emirlikleri için 30 veya 90 günlük turistik e-vize. İş ve turizm amaçlı seyahatler için uygundur.</p>
                      <div className="grid md:grid-cols-2 gap-3">
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Süre:</strong> 2-3 iş günü</p>
                        </div>
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Geçerlilik:</strong> 30 veya 90 gün</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-cream-50 rounded-2xl p-6 border-2 border-cream-200">
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-navy-900 rounded-xl flex items-center justify-center flex-shrink-0">
                      <span className="text-3xl">🇦🇲</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Ermenistan E-Vizesi</h3>
                      <p className="text-navy-600 text-sm mb-3">Turistik ve iş amaçlı seyahatler için 21 veya 120 günlük e-vize. Hızlı onay süreci.</p>
                      <div className="grid md:grid-cols-2 gap-3">
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Süre:</strong> 1-3 iş günü</p>
                        </div>
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Geçerlilik:</strong> 21 veya 120 gün</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-cream-50 rounded-2xl p-6 border-2 border-cream-200">
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-navy-900 rounded-xl flex items-center justify-center flex-shrink-0">
                      <span className="text-3xl">🇰🇼</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Kuveyt E-Vizesi</h3>
                      <p className="text-navy-600 text-sm mb-3">Turistik amaçlı 90 günlük e-vize. Körfez ülkelerine seyahat için pratik çözüm.</p>
                      <div className="grid md:grid-cols-2 gap-3">
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Süre:</strong> 3-5 iş günü</p>
                        </div>
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Geçerlilik:</strong> 90 gün</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-cream-50 rounded-2xl p-6 border-2 border-cream-200">
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-navy-900 rounded-xl flex items-center justify-center flex-shrink-0">
                      <span className="text-3xl">🇸🇦</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Suudi Arabistan E-Vizesi</h3>
                      <p className="text-navy-600 text-sm mb-3">Turistik amaçlı 1 yıl geçerli çok girişli e-vize. Her girişte 90 güne kadar kalış hakkı.</p>
                      <div className="grid md:grid-cols-2 gap-3">
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Süre:</strong> 24-48 saat</p>
                        </div>
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Geçerlilik:</strong> 1 yıl (çok girişli)</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-cream-50 rounded-2xl p-6 border-2 border-cream-200">
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-navy-900 rounded-xl flex items-center justify-center flex-shrink-0">
                      <span className="text-3xl">🇷🇺</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Rusya E-Vizesi</h3>
                      <p className="text-navy-600 text-sm mb-3">Belirli bölgeler için 16 günlük tek girişli e-vize. Moskova, St. Petersburg ve diğer bölgeler.</p>
                      <div className="grid md:grid-cols-2 gap-3">
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Süre:</strong> 4 iş günü</p>
                        </div>
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Geçerlilik:</strong> 16 gün</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-cream-50 rounded-2xl p-6 border-2 border-cream-200">
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-navy-900 rounded-xl flex items-center justify-center flex-shrink-0">
                      <span className="text-3xl">🇻🇳</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Vietnam E-Vizesi</h3>
                      <p className="text-navy-600 text-sm mb-3">Turistik ve iş amaçlı 30 veya 90 günlük e-vize. Tek veya çok girişli seçenekler.</p>
                      <div className="grid md:grid-cols-2 gap-3">
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Süre:</strong> 3 iş günü</p>
                        </div>
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Geçerlilik:</strong> 30 veya 90 gün</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-cream-50 rounded-2xl p-6 border-2 border-cream-200">
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-navy-900 rounded-xl flex items-center justify-center flex-shrink-0">
                      <span className="text-3xl">🇨🇺</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Küba Turist Kartı</h3>
                      <p className="text-navy-600 text-sm mb-3">Turistik amaçlı 30 günlük turist kartı. Küba seyahatleri için zorunlu belge.</p>
                      <div className="grid md:grid-cols-2 gap-3">
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Süre:</strong> 2-3 iş günü</p>
                        </div>
                        <div className="bg-white rounded-lg p-3">
                          <p className="text-navy-700 text-sm"><strong>Geçerlilik:</strong> 30 gün</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                E-Vize Başvuru Süreci
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-gradient-to-r from-navy-900 to-navy-800 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">1</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Ülke ve Vize Türü Seçimi</h3>
                      <p className="text-cream-200">Gideceğiniz ülke ve seyahat amacınıza uygun e-vize türü belirlenir.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-cream-400 to-cream-300 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">2</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Evrak Hazırlığı</h3>
                      <p className="text-navy-700">Pasaport fotokopisi, fotoğraf ve diğer gerekli belgeler hazırlanır.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-navy-800 to-navy-700 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">3</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Online Başvuru</h3>
                      <p className="text-cream-200">İlgili ülkenin resmi e-vize sistemine başvuru yapılır ve ücret ödenir.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-cream-300 to-cream-200 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">4</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Onay Bekleme</h3>
                      <p className="text-navy-700">Başvuru 24-72 saat içinde değerlendirilir ve sonuç e-posta ile bildirilir.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-navy-900 to-navy-800 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">5</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">E-Vize Alımı</h3>
                      <p className="text-cream-200">Onaylanan e-vize e-posta ile gönderilir. Yazdırarak seyahatinizde yanınızda taşıyın.</p>
                    </div>
                  </div>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Genel Gerekli Evraklar
              </h2>
              <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6 md:p-8 mb-8">
                <p className="text-cream-200 text-base md:text-lg mb-6">
                  E-Vize başvuruları için genellikle minimum evrak gerekir. Ülkeye göre değişiklik gösterebilir:
                </p>
                <ul className="space-y-3 text-cream-100">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Pasaport:</strong> En az 6 ay geçerlilik süresi olan pasaportun renkli taraması</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Fotoğraf:</strong> Biyometrik standartlara uygun dijital fotoğraf</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Uçak Bileti:</strong> Gidiş-dönüş uçak rezervasyonu (bazı ülkeler için)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Otel Rezervasyonu:</strong> Konaklama belgesi (bazı ülkeler için)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Kredi Kartı:</strong> Online ödeme için geçerli kredi kartı</span>
                  </li>
                </ul>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                E-Vize ile İlgili Önemli Bilgiler
              </h2>
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-printer-line text-2xl text-navy-900 mr-2"></i>
                    Yazdırma Zorunluluğu
                  </h3>
                  <p className="text-navy-600 text-sm">E-Vize onayını mutlaka yazdırın ve seyahatinizde yanınızda taşıyın. Havaalanında ve gümrükte gösterilmesi gerekir.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-calendar-line text-2xl text-navy-900 mr-2"></i>
                    Geçerlilik Süresi
                  </h3>
                  <p className="text-navy-600 text-sm">E-Vize geçerlilik süresi ülkeye göre değişir. Vize süresi dolmadan ülkeden çıkış yapmanız gerekir.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-refresh-line text-2xl text-navy-900 mr-2"></i>
                    Uzatma İmkanı
                  </h3>
                  <p className="text-navy-600 text-sm">Çoğu e-vize uzatılamaz. Süre dolmadan yeni başvuru yapmanız gerekebilir.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-shield-check-line text-2xl text-navy-900 mr-2"></i>
                    Onay Garantisi
                  </h3>
                  <p className="text-navy-600 text-sm">E-Vize başvuruları genellikle yüksek onay oranına sahiptir, ancak garanti değildir. Doğru bilgi vermek önemlidir.</p>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Profesyonel E-Vize Danışmanlığı
              </h2>
              <div className="bg-gradient-to-br from-cream-400 to-cream-300 rounded-2xl p-6 md:p-8 mb-8">
                <p className="text-navy-900 text-base md:text-lg mb-6">
                  E-Vize başvuruları basit görünse de, hatalı bilgi veya eksik evrak nedeniyle reddedilebilir. Profesyonel danışmanlık hizmetimiz ile:
                </p>
                <ul className="space-y-3 text-navy-900">
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Başvuru formunuzu hatasız şekilde dolduruyoruz</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Evraklarınızı standartlara uygun hazırlıyoruz</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Başvuru sürecini sizin adınıza takip ediyoruz</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">E-Vize onayını size ulaştırıyoruz</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Seyahat öncesi gerekli bilgilendirmeleri yapıyoruz</span>
                  </li>
                </ul>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Sıkça Sorulan Sorular
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">E-Vize ne kadar sürede çıkar?</h3>
                  <p className="text-navy-600">Ülkeye göre değişir, genellikle 24-72 saat içinde onaylanır. Bazı ülkeler aynı gün onay verebilir.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">E-Vize ile ne kadar kalabilirim?</h3>
                  <p className="text-navy-600">Ülkeye ve vize türüne göre 14 günden 90 güne kadar değişir. Bazı ülkeler 1 yıl geçerli çok girişli e-vize verir.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">E-Vize reddedilirse ne olur?</h3>
                  <p className="text-navy-600">Ret nedeni analiz edilerek yeniden başvuru yapılabilir. Ücret genellikle iade edilmez.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">E-Vize ile çalışabilir miyim?</h3>
                  <p className="text-navy-600">Hayır, e-vizeler genellikle turistik amaçlıdır. Çalışma için ayrı vize gerekir.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 md:py-20 bg-gradient-to-br from-navy-900 to-navy-800">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-display text-3xl md:text-5xl font-bold text-cream-100 mb-4 md:mb-6">
              E-Vize Başvurunuzu Başlatın
            </h2>
            <p className="text-cream-300 text-base md:text-xl mb-6 md:mb-8 leading-relaxed">
              Hızlı ve kolay e-vize hizmetleri için bizimle iletişime geçin
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-green-600 text-white rounded-full font-bold text-base md:text-xl hover:bg-green-700 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-cream-400 text-navy-900 rounded-full font-bold text-base md:text-xl hover:bg-cream-300 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default EVizePage;